import { render, staticRenderFns } from "./AcademicPositionsIndex.vue?vue&type=template&id=3079ccc2"
import script from "./AcademicPositionsIndex.vue?vue&type=script&lang=js"
export * from "./AcademicPositionsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports